import typography from './typography';
import {Breakpoint} from './types';

type VariantKey = keyof typeof typography;

type ResponsiveVariantMap = Partial<Record<Breakpoint, VariantKey>>;

export function getTypographyVariantSx(variants: ResponsiveVariantMap) {
  const sx = {
    fontSize: {} as Record<string, string | number>,
    lineHeight: {} as Record<string, string | number>,
    fontWeight: {} as Record<string, number>
  };

  for (const [breakpoint, variant] of Object.entries(variants)) {
    const style = typography[variant];
    if (style) {
      sx[breakpoint] = style;
    }
  }

  return sx;
}
